import { Pipe , PipeTransform } from '@angular/core'

@Pipe({
		name: 'riskAssessment'
})
export class RiskAssessment implements PipeTransform {
		public transform(value: 'released' | 'no-released' | 'required' | 'requested'): string {
				if (value === 'released' || value === 'required') {
						return 'REALIZADA'
				} else if (value === 'no-released') {
						return 'NÃO REQUERIDA'
				} else if (value === 'requested') {
						return 'REQUERIDA'
				}
		}
}
